module.exports = __webpack_public_path__ + "img/logo-um-fkkt-ang.385f2c4b.png";